<div class="loading" *ngIf="display"></div>